const Sessions: React.FC<{}> = () => {
 
  return <div>Seções</div>;
}

export default Sessions;